import { toast } from "react-toastify";

export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const imageURL = baseURL + "uploads/";
export const apiUrl = baseURL + "api";

export const api = apiUrl;

export const saveRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const getRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const dropdownData = async (
  responseData,
  fieldName,
  selectedFieldName,
  isOtherDependentOnThis
) => {
  try {
    if (!responseData && responseData.length == 0) {
      return []; // Return empty array if no data is available
    }
    var options = [];
    responseData.forEach((element) => {
      options.push({
        label: element[fieldName],
        value: element.id,
        fieldName: selectedFieldName,
        isOtherDependentOnThis,
        data: responseData,
      });
    });
    const dropdownResponseData = [{ options: options }];
    return dropdownResponseData;
  } catch (error) {
    console.error("Error fetching data:", error);
    // Handle errors appropriately (throw error, display error message, etc.)
    throw error; // Re-throw the error for further handling if needed
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "0";
  const num = Number(value);
  if (isNaN(num)) return "0";
  const formatted = num.toFixed(2).toString();
  return formatted.replace(/\.00$/, "");
};

export const uploadExelFile = async (file, endpoint, options = {}) => {
  try {
    const formData = new FormData();

    if (options.useSchemaPayload) {
      const schema = localStorage.getItem("schema");
      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      if (!schema) {
        throw new Error("Schema not found in localStorage");
      }
      if (!userDetails.id) {
        throw new Error("User ID not found in localStorage");
      }
      formData.append("schema_name", schema);
      formData.append("created_by", userDetails.id);
      formData.append("file", file);
    } else {
      formData.append("file", file);
    }

    // Add any additional data
    if (options.additionalData) {
      Object.entries(options.additionalData).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    const apiUrlToUse = apiUrl;
    const fullUrl = apiUrlToUse + endpoint;

    const response = await fetch(fullUrl, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      let errorMessage = `Server error: ${response.status} ${response.statusText}`;

      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorData.error || errorMessage;
      } catch (e) {
        // If response is not JSON, try to get text
        try {
          const errorText = await response.text();
          if (errorText) errorMessage = errorText;
        } catch (textError) {
          // Ignore if we can't get text either
        }
      }

      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};

export const downloadFile = async (endpoint, options = {}) => {
  try {
    const { fileName = "download.xlsx" } = options;

    // Determine which API URL to use
    const apiUrlToUse = apiUrl;

    // Sending GET request to backend
    const response = await fetch(apiUrlToUse + endpoint, {
      method: "GET",
      headers: {
        // Add any required headers here
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    // Get the blob from the response
    const blob = await response.blob();

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    return { success: true };
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error; // Propagate the error for handling
  }
};
